import React, { FunctionComponent, ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../../utils/PropTypesDefinitions'
import ProgressIndicator from '../../../BaseComponents/ProgressBar/ProgressIndicator'
import ButtonFont from '../../../Theme/Fonts/Button'

export type LiveMatchResultProps = {
    homeScore: string
    awayScore: string
    progressPercent?: number
} & TestID

const veryThinSpace = String.fromCodePoint(0x200a)
const LiveMatchResult: FunctionComponent<LiveMatchResultProps> = ({
    homeScore,
    awayScore,
    progressPercent,
    testID,
}): ReactElement => {
    return (
        <Grid testID={testID} centerVertical height={20} noExpand overflow="hidden">
            <Grid noExpand height={20} borderRadius={1} overflow="hidden">
                <Grid
                    centerVertical
                    noExpand
                    paddingX={2}
                    backgroundColor="onyx-5"
                    height={progressPercent ? 18 : 20}
                >
                    <ButtonFont
                        color="pearl"
                        fontSize="FS16"
                        lineHeight="LH20"
                    >{`${homeScore}${veryThinSpace}:${veryThinSpace}${awayScore}`}</ButtonFont>
                </Grid>
                {progressPercent ? <ProgressIndicator indicatorPercent={progressPercent} /> : null}
            </Grid>
        </Grid>
    )
}

export default memo(LiveMatchResult)
